angular.module('zc.commonApi')
.factory 'Ip', ($q, Api) ->
  class Ip
    @get: ->
      Api.get "/api/ip/"
      .then (res) ->
        if res.data.success
          res.data.ip
        else
          $q.reject res



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/ip.service.coffee